import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { BLOCKS } from '@contentful/rich-text-types';
import createQueryHook from '@segment/utils/createQueryHook';
import { createFsCacheProxy } from '@segment/utils/fsCache';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
export var fetchLandingLegalData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var enabled, filterData, cachedFetch;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);

            filterData = function filterData(fields) {
              var _fields$pageBody;

              return (_fields$pageBody = fields.pageBody) === null || _fields$pageBody === void 0 ? void 0 : _fields$pageBody.content.filter(function (node) {
                return node.nodeType === BLOCKS.UL_LIST;
              }).flatMap(function (_ref2) {
                var content = _ref2.content;
                return content;
              }).map(function (item) {
                return {
                  url: item.content[0].content[1].data.uri,
                  label: item.content[0].content[1].content[0].value
                };
              });
            };

            _context.next = 4;
            return createFsCacheProxy(["legal/legalDataQuery"], function () {
              return client.get("/content/rawEntries/legalPage/7mEnTEkgvP2YIjk69KS7pn").then(function (data) {
                var _data$fields;

                return (_data$fields = data.fields) !== null && _data$fields !== void 0 ? _data$fields : null;
              }).then(function (fields) {
                return fields && {
                  title: fields.title,
                  contents: filterData(fields)
                };
              });
            }, {
              enabled: enabled
            });

          case 4:
            cachedFetch = _context.sent;
            return _context.abrupt("return", cachedFetch());

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchLandingLegalData(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var fetchAllLegalData = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client) {
    var enabled, cachedFetch;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context2.next = 3;
            return createFsCacheProxy(["legal/allLegalDataQuery"], function () {
              return client.get("/content/rawEntries/legalPage/").then(function (data) {
                var _data$items;

                return (_data$items = data.items) !== null && _data$items !== void 0 ? _data$items : null;
              });
            }, {
              enabled: enabled
            });

          case 3:
            cachedFetch = _context2.sent;
            return _context2.abrupt("return", cachedFetch());

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllLegalData(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var pageQuery = function pageQuery(client, slug) {
  return [["legal/legalPageDataQuery", slug], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var allLegal, legal;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return fetchAllLegalData(client);

          case 3:
            allLegal = _context3.sent;
            legal = allLegal.find(function (s) {
              var _s$fields$url;

              return (_s$fields$url = s.fields.url) === null || _s$fields$url === void 0 ? void 0 : _s$fields$url.includes(slug);
            });

            if (legal) {
              _context3.next = 7;
              break;
            }

            throw new Error("Legal data is empty");

          case 7:
            return _context3.abrupt("return", legal.fields);

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](0);
            console.error("Failed to find legal page with ".concat(slug, ". Underlying error: ").concat(_context3.t0));

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 10]]);
  }))];
};
export var usePageQuery = createQueryHook(pageQuery, useStaticSiteBackend, {
  staleTime: Infinity
});